<template>
  <div>
    <HeaderPayment />

    <div class="misc-wrapper">
      <div>
        <b-container class="mt-2 col-sm-12 mb-5 flex-fill container">
          <b-row>
            <b-col class="col-md-6 col-sm-12 col-lg-6  col-xl-5 columna">
              <div v-if="bookingDetail">
                <b-card tag="article" class="mb-2 rounded-0">
                  <template #header>
                    <b-row>
                      <div class="col-md-12">
                        <b-icon
                          icon="cart-fill"
                          font-scale="1"
                          animation="fade"
                          aria-hidden="true"
                          class="h4 float-right"
                          style="color: #000000"
                        >
                        </b-icon>
                        <h6 class="mb-0" style="0.75s infinite ease-in-out">
                          Purchased Products
                        </h6>
                      </div>
                    </b-row>
                  </template>
                  <!-- Products -->
                  <table class="table animate__animated animate__bounce">
                    <tbody>
                      <tr >
                        <td class="text-small-cart roomSelect"  :id="'room'+bookingDetail.id" @click="sendPayBook(bookingDetail)">
                          <span class="" v-if="bookingDetail.datein">
                            <span style="font-weight: bold; font-size: 16px"
                              >{{ bookingDetail.roomtypename }}
                            </span>
                            <br />

                            <table class="content booking" >
                              <tr></tr>

                              <tr  >
                                <td>
                                  <span style="font-weight: bold"
                                    >Check-In:</span
                                  >
                                  <span style="">
                                    {{ bookingDetail.datein }}</span
                                  >
                                </td>

                                <td>
                                  <span style="font-weight: bold"
                                    >Check-Out:</span
                                  >
                                  <span style="">
                                    {{ bookingDetail.dateout }}</span
                                  >
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <span style="font-weight: bold">Nights:</span>
                                  {{ bookingDetail.nights }}
                                </td>
                                <td>
                                  <span style="font-weight: bold">Adults:</span>
                                  {{ bookingDetail.adults }}
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <span style="font-weight: bold"
                                    >Childrens:</span
                                  >
                                  {{ bookingDetail.children }}
                                </td>
                              </tr>
                            </table>

                            <table
                              class="content booking"
                              v-if="bookingDetail.datein"
                            >
                              <tr>
                                <td>
                                  <span style="font-weight: bold">Plan:</span>
                                  {{ bookingDetail.mealplancode }}
                                </td>
                                    <td>
                                  <span style="font-weight: bold">Balance:</span>
                                  $ {{ bookingDetail.orderdetail.balance }}  {{ bookingDetail.orderdetail.currency_code }}
                                </td>
                              </tr>
                           
                            </table>
                          </span>
                          <span v-else class="">
                            <span class="titleProduc" style="font-weight: bold"
                              >{{ bookingDetail.bookingDetailsold }}
                            </span>

                            <span class=" display-inline" style="font-weight: bold"
                              >Operation Date:
                            </span>
                            <span class="display-inline">
                              {{ bookingDetail.operationdate }}
                            </span>
                          </span>
                        </td>
                      </tr>
                      <hr />

               
                    </tbody>
                  </table>
                  <!-- Product end -->
                </b-card>
    <article class="card mb-2 rounded-0">
        
                  <div class="card-body">
                    <table class="table animate__animated animate__bounce">
                      <tbody>
                         <h4 class="listPayTitle">Totals</h4>
                         <tr class="text-small-cart row">
                        <span class="col-6" style="text-align: right;margin: 0 0px 0px -11px;">
                          <span class="text-right">Initial Payment:</span>
                         $ {{
                            (
                              bookingDetail.orderdetail.firstpay * bookingDetail.orderdetail.currency_value 
                            ).toFixed(2)
                          }}
                          {{ bookingDetail.orderdetail.currency_code }}
                        </span>
                          <span class="col-6"> </span>
                      </tr>
                      <hr />
                      <tr class="text-small-cart row">
                        <span class="col-6">
                          <span  style="font-weight: bold">Total Balance:</span>
                         $ {{
                            (
                              bookingDetail.total * bookingDetail.orderdetail.currency_value 
                            ).toFixed(2)
                          }}
                          {{  bookingDetail.orderdetail.currency_code }}
                        </span>
                        <span class="col-6">
                         <span  style="font-weight: bold"> Paid out:</span>
                         $ {{ (sum * bookingDetail.orderdetail.currency_value ).toFixed(2) }}
                          {{  bookingDetail.orderdetail.currency_code }}
                        </span>
                      </tr>
                      <hr />
                        
                      <tr class="total">
                        <span>
                          Current / Remaining Balance :
                          $ {{
                            (
                              (bookingDetail.total - sum) *
                              bookingDetail.orderdetail.currency_value 
                            ).toFixed(2)
                          }}
                          {{ bookingDetail.orderdetail.currency_code }}
                        </span>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </article>
                <article class="card mb-2 rounded-0" v-if="sum != 0">
            
                  <div class="card-body">
                    <table class="table animate__animated animate__bounce">
                      <tbody>
                        <tr >
                        <h4 class="listPayTitle">Transactions</h4>
                        <div>
                          <table class="listPay">
                            <tr>
                              <th>Date</th>
                              <th>Num</th> 
                              <th>Amount</th>
                              <th>Reference</th>
                              <th>Status</th>
                              <th>Currency</th>
                            </tr>
                            <tr
                              v-for="listPay in listPayOrders"
                              :key="listPay.id"
                            >
                              <td>
                                {{
                                  listPay.date_transaction_bank
                                    ? listPay.date_transaction_bank
                                    : ""
                                }}
                              </td>
                                   <td>
                                {{
                                    listPay.cc_bank
                                }}
                              </td>
                             
                              <td>$ {{ listPay.paid_amount }}</td>
                              <td>
                                {{
                                  listPay.folio_bank ? listPay.folio_bank : ""
                                }}
                              </td>
                              <td>{{ listPay.transactionstatus.name }}</td>
                              <td>{{ listPay.paid_currency.code }}</td>
                            </tr>
                          </table>
                        </div>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </article>

                
                <article class="card mb-2 rounded-0">
                  <div class="card-header">
                    <div class="row">
                      <div class="col-md-12">
                        <svg
                          viewBox="0 0 16 16"
                          width="1em"
                          height="1em"
                          focusable="false"
                          role="img"
                          aria-label="info circle fill"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi-info-circle-fill b-icon bi float-right"
                        >
                          <g>
                            <path
                              fill-rule="evenodd"
                              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                            ></path>
                          </g>
                        </svg>
                        <h6 class="mb-0">Your information</h6>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <table class="table animate__animated animate__bounce">
                      <tbody>
                        <tr class="text-small-cart">
                          <td>
                            <strong> Name </strong>
                            <br />
                            <span>
                              {{ bookingDetail.givenname }}
                              {{ bookingDetail.surname }}
                            </span>
                          </td>
                        </tr>
                        <tr class="text-small-cart">
                          <td>
                            <strong> E-mail </strong>
                            <br />
                            <span>
                              {{ bookingDetail.email }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </article>
              </div>
              <div v-else>
                <div class="alert alert-danger" role="alert">
                  No information found
                </div>
              </div>
            </b-col>

            <div
              v-if="urlbank"
              class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7 containerIframe"
            >
              <iframe class="responsive-iframe" :src="urlbank"> </iframe>
            </div>
            <div
              class="col-12 col-md-6 col-sm-12 col-lg-6 col-xl-7 "
              v-else-if="bookingDetail.total - sum != 10 && sum != 10"
            >
              <div class="checkout-options">
                <b-card>
                  <h3>Pay outstanding balance</h3>
                  <br />
                  <div class="row">
                    <b-col class="col-6 col-md-6 col-sm-6">
                      <ValidationObserver
                        tag="form"
                        @submit.prevent="onSubmit"
                        ref="observer"
                      >
                        <ValidationProvider rules="required" name="balance">
                          <b-input-group
                            slot-scope="{ valid, errors }"
                            prepend="Balance"
                          >
                            <b-form-input
                              type="number"
                              step=".01"
                              :placeholder="
                                parseFloat(
                                 balancePaid
                                ).toFixed(2) + ' USD'
                              "
                              :state="errors[0] ? false : valid ? true : null"
                              v-model="amount"
                              @input="validTotal()"
                              locale="en"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback>
                              {{ errors[0] }}
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </ValidationProvider>
                      </ValidationObserver>
                    </b-col>
                    <b-col class="col-6 col-md-6 col-sm-6">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-button variant="primary" disabled>
                            💸 Divisa
                          </b-button>
                        </b-input-group-prepend>
                        <b-form-select
                          id="divisaSelect"
                          @change="calcularImportes"
                          v-model="cart.cliente.currency"
                        >
                          <option
                            v-for="cur in currencies"
                            :key="cur.id"
                            :value="cur"
                          >
                            {{ cur.code }}
                          </option>
                        </b-form-select>
                      </b-input-group>
                    </b-col>
                  </div>
                  <!-- <hr> -->
                  <div class="price-details">
                    <div v-if="cart.cliente.currency.code == 'MXN'">
                      <div>
                        <hr />
                        <ul class="list-unstyled">
                          <li class="price-detail">
                            <div class="detail-title detail-total">
                              Tipo de cambio MXN:
                            </div>
                            <div class="detail-amt font-weight-bolder">
                              <b-badge pill>$ {{ tc }}</b-badge>
                            </div>
                          </li>
                          <li class="price-detail">
                            <div class="detail-title detail-total">
                              Total divisa MXN:
                            </div>
                            <div class="detail-amt font-weight-bolder">
                              <b-badge pill>${{ totalDivisa }}</b-badge>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <hr />

                    <div class="float-right" >
                      <div v-if="!loadvalid">
                      <b-button
                        variant="primary"
                        :disabled="validNull||loadvalid"
                        @click="getLinkPay()"
                      >
                        <b-icon-check-square-fill></b-icon-check-square-fill>
                        Checkout
                      </b-button>
                       </div>
                      <div v-else class="text-center" >
                          <b-spinner label="Loading..." variant="success"/>                          
                      </div>
                    </div>
                   
                  </div>
                </b-card>
              </div>
            </div>
            <div
              class="col-12 col-md-7 col-sm-12"
              v-else-if="sum != 0 && bookingDetail.total - sum == 0"
            >
              <div class="checkout-options">
                <b-card>
                  <div class="w-100 text-center">
                    <h2 class="mb-1">This order is paid 😊👌</h2>
                    <img
                      src="/img/error.7cce96d0.svg"
                      alt="Error page"
                      class="img-fluid"
                    />
                  </div>
                </b-card>
              </div>
            </div>
            <div class="col-12 col-md-7 col-sm-12" v-else>
              <div class="checkout-options" v-if="validNull==false">
                <b-card>
                  <div class="w-100 text-center">
                    <h2 class="mb-1">This order was not paid 🕵🏻‍♀️</h2>
                    <img
                      src="/img/error.7cce96d0.svg"
                      alt="Error page"
                      class="img-fluid"
                    />
                  </div>
                </b-card>
              </div>
               <div v-else class="text-center loadingInitiate" >
             <b-spinner label="Loading..." variant="success"/>                          
               </div>
            </div>
          </b-row>
        </b-container>
      </div>
      <FooterPayment> </FooterPayment>
    </div>
  </div>
</template>


<script>
import HeaderPayment from "@/modules/shop/components/HeaderPayment"
import FooterPayment from "@/modules/shop/components/FooterPayment"
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  async mounted() {
    if (this.order) {
      await this.getDataOrder();
      await this.getDaSum();
      if( !this.currencies.length ){
        const currencies = await this.fetchCurrencies()  
        this.setCurrencies(currencies) //muto state currencies en start 
      }
      setCurrencyCustomer()
      this.currencyValue = this.currencies.find(
        (currency) => currency.code === this.bookingDetail.orderdetail.currency_code
      );
    }
  },
  components: {
    HeaderPayment,
    FooterPayment,
  },

  data() {
    return {
      loadvalid:false,
      order: this.$route.query.order,
      urlbank: this.$route.query.urlbank,
      sum: 0,
      amount: "",
      validNull: true,
      currencyValue: 0,
      listPayOrders: [],
      balancePaid:0.00,
      balanceId:0
    };
  },
  computed: {
    ...mapState("shop", ["cart"]),

    ...mapState("groups", ["bookingDetail","roomsTransactions","isloadingProcess"]),
    ...mapState("start", ["currencies"]),
    ...mapState("mySales", ["errorMessageApi", "transactionPay"]),

    subTotal() {
      return (
        Math.round(
          (parseFloat(this.totalDiscountOnAllProducts) +
            parseFloat(this.cart.totalBreakdown.total)) *
            100
        ) / 100
      ).toFixed(2);
    },
    total() {
      return (Math.round(this.amount * 100) / 100).toFixed(2);
    },
    tc() {
      const currencieValor = this.cart.cliente.currency
        ? this.cart.cliente.nameprefix
        : 1;
      return (Math.round(currencieValor * 100) / 100).toFixed(2);
    },
    totalDivisa() {
      var amount = this.amount;
      if (amount == "") {
        amount = 0;
      } else {
        amount = this.amount;
      }
      const currencieValor = this.cart.cliente.currency
        ? this.cart.cliente.currency.value
        : 1;
      return (
        Math.round(parseFloat(amount) * parseFloat(currencieValor) * 100) / 100
      ).toFixed(2);
    },
  },
  methods: {
    ...mapActions("groups", ["fetchDataOrderBooking","fetchTransactionsBooking"]),
    ...mapActions("mySales", ["fetchTransactionPay"]),
    ...mapActions("start", ["fetchCurrencies"]),
    ...mapMutations("shop", ["setCurrency"]),     
    ...mapMutations("groups", ["setRoomsTransactions","setLoadingProcess","setRoomsInfo"]),
    ...mapMutations('start',['setCurrencies']),

    setCurrencyCustomer(){
      const cliente = this.cart.cliente
      const { currency } = cliente
      const divisa = toJson( this.currencies.find( currency => currency.code === 'USD' ) )    
      if( !currency ){
        this.setCurrency( divisa )
      }      
    },
    async getDataOrder() {
       await this.fetchDataOrderBooking(this.order);
       await this.fetchTransactionsBooking(this.bookingDetail.orderdetail.orderdetail_id);
       this.order=this.bookingDetail.orderdetail.order_id
       this.balanceId=this.bookingDetail.orderdetail.orderdetail_id
    },
    getDaSum() {
      this.roomsTransactions.forEach((list) => {
        if (list.transactionstatus.name == "Approved") {
          this.sum += parseFloat(list.amount);
        }
        if (list.transactionstatus.name != "Pending") {
          this.listPayOrders.push(list);
        }
      });
    },
    async getLinkPay() {
      const payload = { amount: this.amount, order: this.order,detail:this.balanceId };
     
     this.loadvalid=true
      await this.fetchTransactionPay(payload);
      this.loadvalid=false
      this.urlbank = this.transactionPay.link;
    },
    calcularImportes() {
      const currencieValor = this.cart.cliente.currency
        ? this.cart.cliente.currency.value
        : 1;
      this.divisaTotal = (
        Math.round(
          parseFloat(this.cart.totalBreakdown.total) *
            parseFloat(currencieValor) *
            100
        ) / 100
      ).toFixed(2);
      this.setCurrency(this.cart.cliente.currency);
    },

    validTotal() {
      const total = parseFloat(this.amount);
      const balance = this.bookingDetail.total - this.sum;
      if (total <= balance) {
        this.validNull = false;
      } else {
        this.validNull = true;
      }
      console.log(0);
    },
    sendPayBook(item){
      if(item.booking.id!=undefined && item.partial==true &&this.sum!=0 ){
      var activeClass = document.querySelector(".bg-gradient-success");
      if(activeClass!=null){
        activeClass.classList.remove("bg-gradient-success");
      }
      const isChecked = document.getElementById("room"+item.booking.id)
      isChecked.classList.add('bg-gradient-success')

      this.balancePaid=item.orderdetail.balance     
      }
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
iframe {
  overflow: hidden;
}
.roomSelect {
    cursor: pointer;
    padding: 11px!important;
}
.containerIframe {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 619px;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.alert.alert-danger {
  padding: 9px 0 7px 13px;
}

.container-xl,
.container-lg,
.container-md,
.container-sm,
.container {
  max-width: 1440px;
}

.misc-wrapper {
  display: block;
  flex-basis: 100%;
  min-height: auto;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.container {
  padding-bottom: 62px;
}

.misc-wrapper {
  position: relative;
  height: 100%;
  display: contents;
}
#app > div {
  display: inline-table;
}

tr.total {
  text-align: center;
  padding: 14px 0 0 0;
  display: block;
  font-weight: 600;
  font-size: 18px;
}

tr.text-small-cart.row {
  text-align: center;
}

table.payment {
  background: #fff;
  padding: 27px 12px 25px 15px;
  border-collapse: initial;
  text-align: center;
  margin: 31px auto 105px;
  width: 71%;
}

.card-img-top {
  width: 100%;
  height: 25vh;
  object-fit: cover;
}
.ecommerce-application .grid-view .ecommerce-card .item-img {
  padding-top: 0rem;
  min-height: 0rem;
  display: flex;
  align-items: center;
}
tr.listPay {
  text-align: center;
  font-size: 12px;
}

.listPay th, .listPay td {
    padding: 8px;
    font-size: 12px;
    vertical-align: middle;
}
.listPayTitle {
  text-align: center;
  margin-bottom: 10px;
}
ul.list-unstyled {
  text-align: right;
}
table.content.booking {
  margin: 12px 0 0 0;
}

table.content.booking span {
  padding-right: 5px;
}
table.content.booking tr,
table.content.booking td {
  border: 0;
  padding: 6px 15px 6px 15px;
}

.titleProduc {
  font-weight: bold;
  margin: 3px 0 10px 0;
  display: block;
}

table.listPay {
  margin: 0 auto;
}
.active {
    background: #cccc;
}
.roomSelect{
  cursor: pointer;
}
#roomundefined{
  cursor:default ;
}
.bg-gradient-success, .btn-gradient-success {
    color: #fff;
    transition: all 0.2s ease;
    background-image: linear-gradient(
47deg
, #339e62, #1f8a4e);
    background-repeat: repeat-x;
    background-repeat: repeat;
}
.ddine{
  display: inline-block;
}
.loadingInitiate {
    margin: 20px 0 0 0;
}

@media (max-width: 1380px) {
.listPay th, .listPay td {
    padding: 5px;
    font-size: 10px;
    vertical-align: middle;
}


 }
</style>
<style scoped src="@/assets/css/success.css"></style>
